var _style, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#327DFF;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,6.2h-0.7c-0.2,0-0.3,0.1-0.3,0.3l0,2.3c-1-1.5-2.8-2.6-4.8-2.6c-2.9,0-5.2,2-5.7,4.7 c0,0.2,0.1,0.3,0.3,0.3h0.7c0.1,0,0.3-0.1,0.3-0.2C7.9,9,9.8,7.4,12,7.4c1.9,0,3.4,1.1,4.2,2.7l-3-0.1c-0.2,0-0.3,0.1-0.3,0.3V11 c0,0.2,0.1,0.3,0.3,0.3h4.5c0.1,0,0.3-0.1,0.3-0.3V6.5C18,6.3,17.9,6.2,17.7,6.2z M17.4,12.8h-0.7c-0.1,0-0.3,0.1-0.3,0.2 C16,15,14.2,16.6,12,16.6c-1.9,0-3.5-1.1-4.2-2.7l3,0.1c0.2,0,0.3-0.1,0.3-0.3V13c0-0.1-0.1-0.3-0.3-0.3H6.3C6.1,12.8,6,12.9,6,13 v4.5c0,0.2,0.1,0.3,0.3,0.3h0.6c0.2,0,0.3-0.1,0.3-0.3l0-2.3c1,1.5,2.8,2.6,4.9,2.6c2.8,0,5.2-2,5.7-4.7 C17.7,12.9,17.6,12.8,17.4,12.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/Rotate.3f8733936ec872102972d2ed957542b6.svg";
export { ForwardRef as ReactComponent };